import { useState, useEffect } from 'react';

import { axiosFunction } from '../../common';
import {
    Typography, Table, TableBody, TableCell, TableHead, TableRow, Box,
    Grid, Card, CardMedia, CardContent,
    Fab,
    Dialog,
    DialogContent,
    IconButton,
    Toolbar,
    AppBar,
    Chip,
    Paper,
    Tooltip,
    Slider,
    Stack,
    Button
} from '@mui/material';
import { CloudDownload } from '@mui/icons-material';
import ImageUploading from "react-images-uploading";
import Resizer from "react-image-file-resizer";

// Icons - you can replace these with MUI icons
const CloseIcon = ({ s }) => (
    <svg width={s ? s : 24} height={s ? s : 24} viewBox="0 0 24 24" fill="currentColor">
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
    </svg>
);

const ArrowBackIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.42-1.41L7.83 13H20v-2z" />
    </svg>
);

const ArrowForwardIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />
    </svg>
);

const ZoomInIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
        <path d="M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z" />
    </svg>
);

const ZoomOutIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
        <path d="M7 9h5v1H7z" />
    </svg>
);

const RotateRightIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M15.55 5.55L11 1v3.07C6.06 4.56 2 8.92 2 14s4.06 9.44 9 8.93v-2.02c-3.47.49-6.54-2.22-6.54-5.91 0-3.47 2.49-6.28 5.8-6.28l.74.01V12l4.55-4.45z" />
    </svg>
);

const InfoIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
    </svg>
);

const DownloadIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
    </svg>
);


const TickIcon = ({ s }) => (
    <svg width={s ? s : 24} height={s ? s : 24} viewBox="0 0 24 24" fill="currentColor">
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
    </svg>
);

const PhotoCameraIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <circle cx="12" cy="12" r="3.2" />
        <path d="M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z" />
    </svg>
);


export const UploadImages = ({ images, setImages, showImageErr, setShowImageErr, setRImages, setImgChangeFlag, uploadContainerId, idxno, gindex, gasFields, setGasFields, smokeTestField, setSmokeTestField, selectedPhoto, setSelectedPhoto, currentIndex, setCurrentIndex, setDialogImages }) => {

    const maxNumber = 10;
    const [remAllImg, setRemAllImg] = useState(images && images.length > 1 ? 'show' : 'hide');

    const resizeFile = async (file, imageList, i, idxno, newGasFields, gindex, checklist, newSmokeFields) =>

        new Promise(async (resolve) => {
            Resizer.imageFileResizer(
                file,
                1024,
                1024,
                "JPEG",
                100,
                0,
                async (uri) => {
                    const metadata = {
                        name: file.name,
                        fileSize: (file.size / 1024).toFixed(2) + ' KB',
                        fileType: file.type,
                        compliance: '', //'Y',
                        lastModified: (() => {
                            const date = new Date(file.lastModified);
                            const day = date.getDate().toString().padStart(2, '0');
                            const month = (date.getMonth() + 1).toString().padStart(2, '0');
                            const year = date.getFullYear();
                            const hours = date.getHours().toString().padStart(2, '0');
                            const minutes = date.getMinutes().toString().padStart(2, '0');
                            const seconds = date.getSeconds().toString().padStart(2, '0');
                            return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
                        })()
                    }
                    const img = new Image();
                    img.onload = () => {
                        metadata.dimensions = `${img.width} x ${img.height}`;
                        resolve(metadata);
                    };
                    img.src = URL.createObjectURL(file);
                    //console.log(metadata);
                    resolve(uri);
                    imageList[i]['data_url'] = uri;
                    imageList[i]['metadata'] = metadata;
                    if (newGasFields.length > 0) {
                        // console.log('gas resize');
                        setGasFields(
                            newGasFields.map((e1, ei) => ei === gindex ? { ...e1, checklist: checklist.map((e2, ej) => ej === idxno ? { ...e2, pictures: imageList } : e2) } : e1)
                        );
                    } else if (newSmokeFields.length > 0) {
                        // console.log('smoke resize');
                        setSmokeTestField(
                            newSmokeFields.map((e1, ei) => ei === idxno ? { ...e1, images: imageList } : e1)
                        );
                    } else {
                        // console.log('normal resize');
                        setRImages(imageList);
                    }
                    //console.log(imageList);
                },
                "base64"
            );
        });
    const onImageChange = async (imageList) => {
        setImgChangeFlag(true);
        setShowImageErr(false);

        let newGasFields = gasFields ? [...gasFields] : [];
        let checklist = newGasFields.length > 0 ? newGasFields[gindex].checklist : [];

        let newSmokeFields = smokeTestField ? [...smokeTestField] : [];

        imageList.map((img, i) => img.file ? resizeFile(img.file, imageList, i, idxno, newGasFields, gindex, checklist, newSmokeFields) : newGasFields.length > 0 ? setGasFields(
            newGasFields.map((e1, ei) => ei === gindex ? { ...e1, checklist: checklist.map((e2, ej) => ej === idxno ? { ...e2, pictures: imageList } : e2) } : e1)
        ) : newSmokeFields.length > 0 ? setSmokeTestField(
            newSmokeFields.map((e1, ei) => ei === idxno ? { ...e1, images: imageList } : e1)
        ) : setRImages(imageList));


        // console.log(images);
        if (uploadContainerId === 'supportpictureref') setImages(imageList);

        //setFormField((prev) => ({ ...prev, picture: imageList }));

        if (imageList.length > 1) {
            setRemAllImg('show');
        } else {
            setRemAllImg('hide');
        }
    }


    const openModal = (photos, index) => {
        setDialogImages(photos);
        setSelectedPhoto(photos[index]);
        setCurrentIndex(index);
    };

    const handleImgTypeChange = (index, imgtype) => {
        setImgChangeFlag(true);
        setShowImageErr(false);

        if (gasFields && gasFields.length > 0) {
            let newGasFields = [...gasFields];
            let checklist = newGasFields[gindex].checklist;

            setGasFields(
                newGasFields.map((e1, ei) => ei === gindex ? { ...e1, checklist: checklist.map((e2, ej) => ej === idxno ? { ...e2, pictures: images.map((e3, ek) => ek === index ? { ...e3, metadata: { ...e3.metadata, compliance: imgtype } } : e3) } : e2) } : e1)
            );
        } else if (smokeTestField && smokeTestField.length > 0) {
            let newSmokeFields = smokeTestField ? [...smokeTestField] : [];
            setSmokeTestField(
                newSmokeFields.map((e, i) => i === idxno ? { ...e, images: images.map((e1, ej) => ej === index ? { ...e1, metadata: { ...e1.metadata, compliance: imgtype } } : e1) } : e)
            )
        } else {
            setRImages(images.map((e, i) => i === index ? { ...e, metadata: { ...e.metadata, compliance: imgtype } } : e));

            setImages(images.map((e, i) => i === index ? { ...e, metadata: { ...e.metadata, compliance: imgtype } } : e));

        }
    }

    const handleImgDownload = async (imageUrl) => {
        try {
            //console.log(imageUrl);          

            if (imageUrl.startsWith('data:image/')) {
                // Create a temporary URL for the blob
                // const url = window.URL.createObjectURL(new Blob([response.data_url]));
                const url = imageUrl;

                // Create an anchor element
                const link = document.createElement('a');
                link.href = url;

                // Set the download attribute with the desired file name
                link.download = 'image_' + new Date().getTime() + '.jpg';

                // Append the link to the body, click it, and remove it
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                // Revoke the blob URL to free up memory
                window.URL.revokeObjectURL(url);
            } else {
                const imagename = imageUrl.substring(imageUrl.lastIndexOf('/') + 1);

                const response = await axiosFunction('auth/downloadimage/' + imagename, 'get', {});

                if (response.status === 'success') {
                    // Create a temporary URL for the blob
                    // const url = window.URL.createObjectURL(new Blob([response.data_url]));
                    const url = response.data_url;

                    // Create an anchor element
                    const link = document.createElement('a');
                    link.href = url;

                    // Set the download attribute with the desired file name
                    link.download = imagename;

                    // Append the link to the body, click it, and remove it
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    // Revoke the blob URL to free up memory
                    window.URL.revokeObjectURL(url);
                } else {
                    console.error('Error downloading the image');
                }
            }
        } catch (error) {
            console.error('Error downloading the image:', error);
        }
    };

    const handleCustomRemoveAll = (onImageRemoveAll, idxno) => {

        onImageRemoveAll();
        if (gasFields && gasFields.length > 0) {
            // console.log(1);
            let newGasFields = [...gasFields];
            let checklist = newGasFields[gindex].checklist;
            setGasFields(
                newGasFields.map((e1, ei) => ei === gindex ? { ...e1, checklist: checklist.map((e2, ej) => ej === idxno ? { ...e2, pictures: [] } : e2) } : e1));
        } else if (smokeTestField && smokeTestField.length > 0) {
            //console.log(2);
            let newSmokeFields = smokeTestField ? [...smokeTestField] : [];
            setSmokeTestField(
                newSmokeFields.map((e1, ei) => ei === idxno ? { ...e1, images: [] } : e1)
            )
        } else {
            //  console.log(3);
            setImages([]);
        }

    };

    useEffect(() => {

    }, [images]);


    return (
        <Table sx={{ marginTop: '15px' }}>
            <TableHead className="bg-smoke text-body">
                <TableRow >
                    <TableCell>
                        <Typography
                            component="div"
                            className="sec-title fw-bold"
                        >
                            Upload any supporting picture here
                        </Typography>
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableCell className='img-magnifier-container'>
                        <ImageUploading
                            multiple
                            value={images}
                            onChange={onImageChange}
                            maxNumber={maxNumber}
                            dataURLKey="data_url"
                            acceptType={['jpg', 'jpeg', 'png']}
                        >
                            {({
                                imageList,
                                onImageUpload,
                                onImageRemoveAll,
                                onImageUpdate,
                                onImageRemove,
                                isDragging,
                                dragProps,
                                errors
                            }) => (
                                <div id={uploadContainerId}>
                                    <button type="button" className="btn btn-primary mx-2 my-2 " onClick={onImageUpload}>Choose Images</button>

                                    <button type="button" className={"btn btn-danger mx-2 my-2 " + remAllImg} onClick={() => handleCustomRemoveAll(onImageRemoveAll, idxno)}>Remove all images</button>
                                    <div {...dragProps} className="border border-light p-1" style={{ minHeight: '100px' }}>
                                        <p className="m-1">{isDragging ? "Drop here please" : "Drag & Drop images here to upload"}. Maximum 10 images and JPG, JPEG and PNG image types are allowed.</p>
                                        <Grid container spacing={2}>
                                            {images && images.map((image, index) => (
                                                <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                                                    <Card
                                                        sx={{
                                                            cursor: 'pointer',
                                                            transition: 'all 0.3s',
                                                            '&:hover': {
                                                                transform: 'scale(1.05)',
                                                                boxShadow: 6
                                                            }
                                                        }}

                                                    >

                                                        <CardMedia
                                                            component="img"
                                                            height={50}
                                                            image={image.data_url}
                                                            alt={(image.metadata && image.metadata.name) ? image.metadata.name : 'Image'}
                                                            sx={{ objectFit: 'cover', height: '250px !important' }}
                                                            onClick={() => openModal(images, index)}
                                                        />

                                                        <CardContent sx={{ p: 1 }}>
                                                            {/* <Typography variant="subtitle2" noWrap>
                                                                    {image.metadata.name && image.metadata.name}
                                                                </Typography> */}
                                                            <Box sx={{ display: 'flex', gap: 1, mt: 1, flexWrap: 'wrap' }}>
                                                                <Button variant="contained" color={image.metadata && image.metadata.compliance === 'Y' ? 'success' : 'default'} sx={{ fontSize: '10px' }} className="btn btn-normal" onClick={() => handleImgTypeChange(index, 'Y')}><TickIcon s='16px' /> Compliance</Button>
                                                                <Button variant="contained" color={image.metadata && image.metadata.compliance === 'N' ? 'error' : 'default'} sx={{ fontSize: '10px' }} className="btn btn-normal" onClick={() => handleImgTypeChange(index, 'N')}>
                                                                    <CloseIcon s='16px' /> Non Compliance</Button>
                                                            </Box>
                                                            <div className="image-item__btn-wrapper mt-3">
                                                                <button type="button" onClick={() => onImageUpdate(index)} className="m-1 border-0 bg-white"><i className="fa fa-edit"></i></button>
                                                                <CloudDownload onClick={() => handleImgDownload(image.data_url)} style={{ color: 'blue' }} />
                                                                <button type="button" onClick={() => { onImageRemove(index); if (!images.length || images.length === 1) { setRemAllImg('hide') } else if (!images.length) { setShowImageErr(true) } }} className="m-1 border-0 bg-white"><i className="fa fa-close"></i></button>
                                                            </div>
                                                        </CardContent>

                                                    </Card>
                                                </Grid>
                                            ))}
                                        </Grid>
                                        {!images.length && <label className="w-full error text-red text-sm text-start m-1 pt-5">Supporting picture is required</label>}

                                    </div>
                                    {errors && <div className="text-danger">
                                        {errors.maxNumber && <span>Number of selected images exceed maxNumber</span>}
                                        {errors.acceptType && <span>Your selected file type is not allow</span>}
                                        {errors.maxFileSize && <span>Selected file size exceed maxFileSize</span>}
                                        {errors.resolution && <span>Selected file is not match your desired resolution</span>}
                                    </div>}
                                </div>

                            )}
                        </ImageUploading>

                    </TableCell>
                </TableRow>
            </TableBody>
        </Table>
    );
};


export const ImageDialog = ({ dialogImages, setDialogImages, selectedPhoto, setSelectedPhoto, currentIndex, setCurrentIndex }) => {

    const [zoom, setZoom] = useState(100);
    const [rotation, setRotation] = useState(0);
    const [showInfo, setShowInfo] = useState(false);
    // const [metaData, setMetaData] = useState([]);

    const closeModal = () => {
        setSelectedPhoto(null);
        setZoom(100);
        setRotation(0);
        setShowInfo(false);
    };


    const goToPrevious = () => {
        //console.log(dialogImages);
        const newIndex = currentIndex > 0 ? currentIndex - 1 : dialogImages.length - 1;
        setCurrentIndex(newIndex);
        setSelectedPhoto(dialogImages[newIndex]);
        setZoom(100);
        setRotation(0);
    };

    const goToNext = () => {
        //console.log(dialogImages);
        const newIndex = currentIndex < dialogImages.length - 1 ? currentIndex + 1 : 0;
        //console.log(dialogImages[newIndex]);
        setCurrentIndex(newIndex);
        setSelectedPhoto(dialogImages[newIndex]);
        setZoom(100);
        setRotation(0);
    };

    const handleZoomChange = (event, newValue) => {
        setZoom(newValue);
    };

    const handleRotate = () => {
        setRotation(prev => (prev + 90) % 360);
    };

    const handleImgDownload = async () => {
        try {
            const imageUrl = selectedPhoto.data_url;

            if (imageUrl.startsWith('data:image/')) {
                // Create a temporary URL for the blob
                // const url = window.URL.createObjectURL(new Blob([response.data_url]));
                const url = imageUrl;

                // Create an anchor element
                const link = document.createElement('a');
                link.href = url;

                // Set the download attribute with the desired file name
                link.download = 'image_' + new Date().getTime() + '.jpg';

                // Append the link to the body, click it, and remove it
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                // Revoke the blob URL to free up memory
                window.URL.revokeObjectURL(url);
            } else {
                const imagename = imageUrl.substring(imageUrl.lastIndexOf('/') + 1);

                const response = await axiosFunction('auth/downloadimage/' + imagename, 'get', {});

                if (response.status === 'success') {
                    // Create a temporary URL for the blob
                    // const url = window.URL.createObjectURL(new Blob([response.data_url]));
                    const url = response.data_url;

                    // Create an anchor element
                    const link = document.createElement('a');
                    link.href = url;

                    // Set the download attribute with the desired file name
                    link.download = imagename;

                    // Append the link to the body, click it, and remove it
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    // Revoke the blob URL to free up memory
                    window.URL.revokeObjectURL(url);
                } else {
                    console.error('Error downloading the image');
                }
            }
        } catch (error) {
            console.error('Error downloading the image:', error);
        }
    };


    useEffect(() => {

        const handleKeyPress = (e) => {
            if (!selectedPhoto) return;

            switch (e.key) {
                case 'Escape':
                    closeModal();
                    break;
                case 'ArrowLeft':
                    goToPrevious();
                    break;
                case 'ArrowRight':
                    goToNext();
                    break;
                case 'i':
                case 'I':
                    setShowInfo(prev => !prev);
                    break;
                default:
                    break;
            }
        };

        window.addEventListener('keydown', handleKeyPress);
        return () => window.removeEventListener('keydown', handleKeyPress);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedPhoto, currentIndex]);


    return (
        <>
            {/* Full Screen Modal */}
            <Dialog
                open={!!selectedPhoto}
                onClose={closeModal}
                maxWidth={false}
                fullWidth
                PaperProps={{
                    sx: {
                        bgcolor: 'black',
                        height: '100vh',
                        m: 0,
                        maxHeight: 'none'
                    }
                }}
            >
                {selectedPhoto && (
                    <>
                        {/* Top Toolbar */}
                        <AppBar position="static" sx={{ bgcolor: 'rgba(0,0,0,0.8)' }}>
                            <Toolbar>
                                <Typography variant="h6" sx={{ flexGrow: 1, color: 'white' }}>
                                    {selectedPhoto.metadata && selectedPhoto.metadata.name ? selectedPhoto.metadata.name : selectedPhoto.name ? selectedPhoto.name : ''}
                                </Typography>

                                <Box sx={{ display: 'flex', gap: 1 }}>
                                    <Tooltip title="Zoom Out">
                                        <IconButton
                                            color="inherit"
                                            onClick={() => setZoom(Math.max(zoom - 25, 25))}
                                            disabled={zoom <= 25}
                                        >
                                            <ZoomOutIcon />
                                        </IconButton>
                                    </Tooltip>

                                    <Tooltip title="Zoom In">
                                        <IconButton
                                            color="inherit"
                                            onClick={() => setZoom(Math.min(zoom + 25, 300))}
                                            disabled={zoom >= 300}
                                        >
                                            <ZoomInIcon />
                                        </IconButton>
                                    </Tooltip>

                                    <Tooltip title="Rotate">
                                        <IconButton color="inherit" onClick={handleRotate}>
                                            <RotateRightIcon />
                                        </IconButton>
                                    </Tooltip>

                                    <Tooltip title="Info">
                                        <IconButton
                                            color="inherit"
                                            onClick={() => setShowInfo(!showInfo)}
                                        >
                                            <InfoIcon />
                                        </IconButton>
                                    </Tooltip>

                                    <Tooltip title="Download">
                                        <IconButton color="inherit" onClick={handleImgDownload}>
                                            <DownloadIcon />
                                        </IconButton>
                                    </Tooltip>

                                    <Tooltip title="Close">
                                        <IconButton color="inherit" onClick={closeModal}>
                                            <CloseIcon />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            </Toolbar>
                        </AppBar>

                        {/* Image Display */}
                        <DialogContent
                            sx={{
                                p: 0,
                                bgcolor: 'black',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                position: 'relative',
                                overflow: 'hidden'
                            }}
                        >
                            {/* Navigation Buttons */}
                            <Fab
                                size="medium"
                                sx={{
                                    position: 'absolute',
                                    left: 16,
                                    zIndex: 10,
                                    bgcolor: 'rgba(255,255,255,0.9)',
                                    '&:hover': { bgcolor: 'rgba(255,255,255,1)' }
                                }}
                                onClick={goToPrevious}
                            >
                                <ArrowBackIcon />
                            </Fab>

                            <Fab
                                size="medium"
                                sx={{
                                    position: 'absolute',
                                    right: 16,
                                    zIndex: 10,
                                    bgcolor: 'rgba(255,255,255,0.9)',
                                    '&:hover': { bgcolor: 'rgba(255,255,255,1)' }
                                }}
                                onClick={goToNext}
                            >
                                <ArrowForwardIcon />
                            </Fab>

                            {/* Zoom Slider */}
                            <Paper
                                sx={{
                                    position: 'absolute',
                                    bottom: 16,
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    p: 2,
                                    zIndex: 10,
                                    bgcolor: 'rgba(255,255,255,0.9)'
                                }}
                            >
                                <Stack direction="row" spacing={2} alignItems="center">
                                    <ZoomOutIcon />
                                    <Slider
                                        value={zoom}
                                        onChange={handleZoomChange}
                                        min={25}
                                        max={300}
                                        step={25}
                                        sx={{ width: 150 }}
                                    />
                                    <ZoomInIcon />
                                    <Typography variant="body2" sx={{ minWidth: 60 }}>
                                        {zoom}%
                                    </Typography>
                                </Stack>
                            </Paper>

                            {/* Image */}
                            <Box
                                component="img"
                                src={selectedPhoto.data_url}
                                alt={"Big Show"}
                                sx={{
                                    maxWidth: '100%',
                                    maxHeight: '100%',
                                    objectFit: 'contain',
                                    transform: `scale(${zoom / 100}) rotate(${rotation}deg)`,
                                    transition: 'transform 0.3s ease'
                                }}
                            />

                            {/* Photo Counter */}
                            <Chip
                                label={`${currentIndex + 1} / ${dialogImages.length}`}
                                sx={{
                                    position: 'absolute',
                                    top: 16,
                                    right: 16,
                                    bgcolor: 'rgba(255,255,255,0.9)'
                                }}
                            />
                        </DialogContent>
                        {showInfo &&
                            <div
                                className="position-absolute text-black p-4 rounded"
                                style={{
                                    left: '5rem',
                                    top: '5rem',
                                    backgroundColor: 'white',
                                    backdropFilter: 'blur(8px)',
                                    WebkitBackdropFilter: 'blur(8px)',
                                    maxWidth: '32rem'
                                }}
                            >
                                <h6 className="fw-semibold mb-3 d-flex align-items-center">
                                    <PhotoCameraIcon />
                                    Photo Details
                                </h6>
                                {selectedPhoto.metadata && (
                                    <div className="small">
                                        <div className="d-flex justify-content-between mb-2">
                                            <span style={{ opacity: 0.75 }}>Name: </span>
                                            <span>{selectedPhoto.metadata.name}</span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2">
                                            <span style={{ opacity: 0.75 }}>Size: </span>
                                            <span>{selectedPhoto.metadata.fileSize}</span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2">
                                            <span style={{ opacity: 0.75 }}>Dimensions: </span>
                                            <span>{selectedPhoto.metadata.dimensions}</span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2">
                                            <span style={{ opacity: 0.75 }}>Date & Time: </span>
                                            <span>{selectedPhoto.metadata.lastModified}</span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <span style={{ opacity: 0.75 }}>Type: </span>
                                            <span>{selectedPhoto.metadata.fileType}</span>
                                        </div>
                                    </div>)}
                            </div>

                        }

                    </>
                )}
            </Dialog >
        </>
    );
}
